module.exports = __webpack_public_path__ + "img/red_006.0ea478ea.png";